"use client";

import React, { useState, useEffect } from "react";
import { updateSession, fetchSessionById } from "../../api/session.api";
import { generateTimeSlots } from "../../utils/time.util";


const EditSessionModal = ({ sessionId, dome, onClose, onUpdated }) => {
  const [sessionData, setSessionData] = useState({
    name: "",
    startTime: "", // "10:45 AM" format
    duration: "",
  });
  const timeSlots = generateTimeSlots(30);


  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadSession = async () => {
      try {
        const data = await fetchSessionById(sessionId);
        if (data) {
          setSessionData({
            startTime: data.startTime || "",
          });

        }
      } catch (err) {
        console.error(err);
        setError("Failed to load session details");
      } finally {
        setLoading(false);
      }
    };
    loadSession();
  }, [sessionId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTimeChange = (e) => {
    setSessionData((prev) => ({ ...prev, startTime: e.target.value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      await updateSession(sessionId, {
        startTime: sessionData.startTime,
      });
      if (onUpdated) onUpdated();
      onClose();
    } catch (err) {
      console.error(err);
      setError(err?.message || "Failed to update timeslot");
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return <div className="modal-body text-center">Loading session...</div>;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
      <div
        className="modal show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Edit timeslot for:{" "}
                <span className="text-primary">{dome?.domeName || "N/A"}</span>
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Start Time</label>
                    <select
                      name="startTime"
                      value={sessionData.startTime}
                      onChange={handleTimeChange}
                      className="form-select"
                      required
                    >
                      <option value="">Select Start Time</option>
                      {timeSlots.map((slot) => (
                        <option key={slot} value={slot}>
                          {slot}
                        </option>
                      ))}
                    </select>
                  </div>

                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={saving}
                >
                  {saving ? "Updating..." : "Update Timeslot"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSessionModal;
